import { ScreenType, ParamsType } from './NavigatorContext.interface';

const reducer = (
    state: { stack: Array<{ screen: ScreenType; params?: ParamsType }> },
    action: any
): { stack: Array<{ screen: ScreenType; params?: ParamsType }> } => {
    switch (action.type) {
        case 'NAVIGATE': {
            const screenIndex = state.stack.findIndex(
                (screen) => screen.screen === action.screen && screen.params === action.params
            );
            if (screenIndex >= 0) {
                const newStack = state.stack.slice(0, screenIndex + 1);
                return { stack: newStack };
            }
            return {
                stack: [...state.stack, { screen: action.screen, params: action.params || {} }],
            };
        }
        case 'GO_BACK':
            if (state.stack.length > 1) {
                const newStack = state.stack.slice(0, -1);
                return { stack: newStack };
            }
            return state;
        case 'PUSH':
            return {
                stack: [...state.stack, { screen: action.screen, params: action.params || {} }],
            };
        case 'POP':
            if (state.stack.length) {
                const newStack = state.stack.slice(0, -1);
                return { stack: newStack };
            }
            return state;
        case 'CLEAN':
            return { stack: [] };
        default:
            return state;
    }
};

export default reducer;
